import { PictureInfo } from '../../apis/serviceHistoryApi';
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { ChevronLeft as PreviousIcon, ChevronRight as NextIcon, Close as CloseIcon } from '@mui/icons-material';

type PictureDialogProps = {
  picture: PictureInfo | null;
  onCloseClicked: () => void;
  onPreviousClicked: () => void;
  onNextClicked: () => void;
  hasPrevious?: boolean;
  hasNext?: boolean;
};

const PictureDialog: React.FC<PictureDialogProps> = ({ picture, onCloseClicked, onPreviousClicked, onNextClicked, hasPrevious, hasNext }) => {
  return (
    picture && (
      <Dialog sx={{ minWidth: 150 }} open={!!picture} onClose={(_evt, reason) => (reason === 'backdropClick' ? onCloseClicked() : '')}>
        <Box display="flex">
          <Box flexGrow={1} marginRight={1} minWidth={70} sx={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>
            <DialogTitle
              height={45}
              position="relative"
              title={picture?.caption}
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                paddingRight: 0,
                paddingLeft: { xs: 3, sm: 4 },
                paddingTop: '14px',
              }}
            >
              {picture?.caption || <Box>&nbsp;</Box>}
            </DialogTitle>
          </Box>
          <Box flexGrow={0} minWidth={122} mt={1}>
            <IconButton
              aria-label="previous"
              disabled={!hasPrevious}
              onClick={hasPrevious ? onPreviousClicked : () => {}}
              sx={{
                padding: 1,
              }}
            >
              <PreviousIcon
                sx={(theme) => ({
                  width: 32,
                  height: 32,
                  color: hasPrevious ? theme.palette.secondary.main : theme.palette.action.disabled,
                })}
              />
            </IconButton>
            <IconButton
              aria-label="next"
              disabled={!hasNext}
              onClick={hasNext ? onNextClicked : () => {}}
              sx={{
                padding: 1,
              }}
            >
              <NextIcon
                sx={(theme) => ({
                  width: 32,
                  height: 32,
                  color: hasNext ? theme.palette.secondary.main : theme.palette.action.disabled,
                })}
              />
            </IconButton>
            <IconButton
              aria-label="close"
              onClick={onCloseClicked}
              sx={(theme) => ({
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        <DialogContent sx={{ px: { xs: 2, sm: 3 }, pb: 2, pt: 0, overflow: 'clip', minWidth: 186 }}>
          <Box
            minHeight={150}
            minWidth={180}
            width="100%"
            height="100%"
            component="img"
            src={picture?.photoUrl}
            alt="Pool service photo"
            loading="lazy"
          ></Box>
        </DialogContent>
      </Dialog>
    )
  );
};

export default PictureDialog;
